<template>
  <div class="uploadUser">
    <div class="head">修改登录手机号</div>
    <el-form label-position="right" label-width="120px" :rules="rules" :model="contentObj">
      <el-form-item label="旧手机号" prop="old_phone">
        <el-input
          type="text"
          placeholder="请输入旧的手机号"
          v-model="contentObj.old_phone"
          maxlength="11"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="旧手机验证码" prop="old_captcha">
        <div class="verification-code-container">
          <el-input
            type="text"
            placeholder="请输入旧手机号的验证码"
            v-model="contentObj.old_captcha"
            maxlength="6"
            show-word-limit
            class="verification-code-input"
          ></el-input>
          <el-button
            @click="getVerificationCode"
            class="captcha-btn"
            :disabled="isCodeDisabled"
          >
            {{ codeButtonText }}
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="新手机号" prop="new_phone">
        <el-input
          type="text"
          placeholder="请输入新的手机号"
          v-model="contentObj.new_phone"
          maxlength="11"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="新手机验证码" prop="new_captcha">
        <div class="verification-code-container">
          <el-input
            type="text"
            placeholder="请输入新手机号的验证码"
            v-model="contentObj.new_captcha"
            maxlength="6"
            show-word-limit
            class="verification-code-input"
          ></el-input>
          <el-button
            @click="getVerificationCode2"
            class="captcha-btn"
            :disabled="isCodeDisabled2"
          >
            {{ codeButtonText2 }}
          </el-button>
        </div>
      </el-form-item>
      <!-- <el-form-item label="官网"
        ><el-input
          type="text"
          placeholder="请输入官网地址"
          v-model="contentObj.net"
        ></el-input
      ></el-form-item>
      <el-form-item label="邮箱"
        ><el-input
          type="text"
          placeholder="请输入邮箱地址"
          v-model="contentObj.email"
        ></el-input
      ></el-form-item>
      <el-form-item label="电话号码"
        ><el-input
          type="text"
          placeholder="请输入电话号码"
          v-model="contentObj.phone"
        ></el-input
      ></el-form-item>
      <el-form-item label="简介"
        ><el-input
          type="textarea"
          placeholder="请输入简介"
          v-model="contentObj.introduction"
          maxlength="100"
          show-word-limit
        ></el-input
      ></el-form-item> -->
      <el-form-item>
        <div class="btnList">
          <button class="sucess" @click.prevent="handleSetPhone">确认</button>
          <button class="del">取消</button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {getCode,SetPhone} from "@/api/user.js"
export default {
  data() {
    return {
      contentObj: {
        old_phone: "",
        old_captcha: "",
        new_phone: "",
        new_captcha: "",
       
      },
      old_token:'',
      new_token:'',
      isCodeDisabled: false,
      isCodeDisabled2: false,
      countdown: 60,
      countdown2: 60,
      codeButtonText: "获取验证码",
      codeButtonText2: "获取验证码",
      rules:{
        old_phone:[{required:true,message:'请输入旧手机号',trigger:'blur'}],
        old_captcha:[{required:true,message:'请输入旧手机验证码',trigger:'blur'}],
        new_phone:[{required:true,message:'请输入新手机号',trigger:'blur'}],
        new_captcha:[{required:true,message:'请输入新手机验证码',trigger:'blur'}],
      }
    };
  },
  methods: {
  async  getVerificationCode() {
      // 这里添加获取验证码的逻辑
      console.log("获取验证码");

      // 开始倒计时

    const res=await getCode({
      phone:this.contentObj.old_phone,
      reason:'reset_phone',
      mock:false
    })
    console.log(res);
    this.isCodeDisabled = true;
      this.countdown = 60;
      this.codeButtonText = `${this.countdown}s后重新获取`;
    this.old_token=res.phone_token
    
      const timer = setInterval(() => {
        this.countdown--;
        this.codeButtonText = `${this.countdown}s后重新获取`;

        if (this.countdown <= 0) {
          clearInterval(timer);
          this.isCodeDisabled = false;
          this.codeButtonText = "获取验证码";
        }
      }, 1000);
    },
   async getVerificationCode2() {
      // 这里添加获取验证码的逻辑
      console.log("获取验证码");

      // 开始倒计时

      const res=await getCode({
      phone:this.contentObj.new_phone,
      reason:'reset_phone',
      mock:false
    })
    console.log(res);
    this.isCodeDisabled2 = true;
      this.countdown2 = 60;
      this.codeButtonText2 = `${this.countdown2}s后重新获取`;
    this.new_token=res.phone_token
      const timer = setInterval(() => {
        this.countdown2--;
        this.codeButtonText2 = `${this.countdown2}s后重新获取`;

        if (this.countdown2 <= 0) {
          clearInterval(timer);
          this.isCodeDisabled2 = false;
          this.codeButtonText2 = "获取验证码";
        }
      }, 1000);
    },
    async handleSetPhone(){
      const res=await SetPhone({
        old_phone:this.contentObj.old_phone,
        old_phone_token:this.old_token,
        old_phone_verification_code:this.contentObj.old_captcha,
        new_phone:this.contentObj.new_phone,
        new_phone_token:this.new_token,
        new_phone_verification_code:this.contentObj.new_captcha,
      })
      Message({
            message: '修改成功',
            type: 'success'
          })
          this.contentObj.old_phone=''
          this.contentObj.old_captcha=''
          this.contentObj.new_phone=''
          this.contentObj.new_captcha=''
      console.log(res);
      
    }
  },
};
</script>

<style scoped>
.verification-code-container {
  display: flex;
  align-items: center;
  width: 570px;
  gap: 20px;
}

.captcha-btn {
  margin-left: auto;
  height: 36px;
  font-size: 14px;
  padding: 0 15px;
  white-space: nowrap;
  flex-shrink: 0;
}
.sucess {
  background-color: #0d53ff;
  color: white;
}
.del {
  background-color: #fff;
  color: #666666;
}
.btnList button {
  width: 80px;
  height: 32px;
  border: 1px solid #e9e9e9;
  margin-right: 20px;
  font-size: 14px;
  border-radius: 4px;
}
::v-deep .el-input {
  width: 570px;
  height: 36px;
}

::v-deep .verification-code-input {
  width: 370px;
  height: 36px;
}
::v-deep .el-textarea textarea {
  width: 570px;
  height: 100px;
}
::v-deep .el-textarea {
  width: 570px;
  height: 100px;
}
.head {
  font-size: 24px;
  font-family: Medium;
  margin-bottom: 27px;
}
.uploadUser {
  margin-top: 24px;
  margin-left: 24px;
  font-family: Regular;
}
</style>
